import { StyledHeaderElement } from '../../../../styles/sharedStyles';
import { StyledEditInputElement } from '../../../../styles/sharedStyles';
import { StyledEditWrapper } from '../../../atoms/SummaryElement/StyledEditWrapper';
import { getLang } from '../../../../strings';

const SummaryEditElementEditableTable = ({
    isAdmin,
    students,
    trainers,
    subjects,
    defaultValues,
    values,
}) => {
    return (
        <StyledEditWrapper>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <select defaultValue={defaultValues.student} ref={values.student}>
                        {students.map((student) => (
                            <option key={student.id} value={student.id}>
                                {student.lastname} {student.firstname}
                            </option>
                        ))}
                    </select>
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <input type="date" defaultValue={defaultValues.date} ref={values.date} />
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <input type="text" defaultValue={defaultValues.hours} ref={values.hours} />
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <select defaultValue={defaultValues.subject} ref={values.subject}>
                        {subjects
                            .filter((el) => el.description)
                            .map((subject) => (
                                <option key={subject.id} value={subject.id}>
                                    {subject.description[getLang()]}
                                </option>
                            ))}
                    </select>
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <select defaultValue={defaultValues.trainer} ref={values.trainer}>
                        {trainers.map((trainer) => (
                            <option key={trainer.id} value={trainer.id}>
                                {trainer.lastname} {trainer.firstname}
                            </option>
                        ))}
                    </select>
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <input type="text" defaultValue={defaultValues.price} ref={values.price} />
                </StyledEditInputElement>
            </StyledHeaderElement>
            {isAdmin ? (
                <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                    <StyledEditInputElement $hasDeclaredWidth="100%">
                        <input
                            type="text"
                            defaultValue={defaultValues.price_trainer}
                            ref={values.price_trainer}
                        />
                    </StyledEditInputElement>
                </StyledHeaderElement>
            ) : null}
        </StyledEditWrapper>
    );
};

export default SummaryEditElementEditableTable;
